import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { COMMERCE } from '@shared/api/endpoints';
import type { CommerceProduct } from '@tailorcast/shared-types';

export function useProductDetail(productId: string | undefined) {
  return useQuery({
    queryKey: ['product', productId],
    queryFn: () => api.get<CommerceProduct>(COMMERCE.PRODUCT(productId!)),
    enabled: !!productId,
  });
}
